import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import UnifiedProjectWizard from '../components/projects/UnifiedProjectWizard';
import Seo from '../components/Seo';

/**
 * /start — describe the project first, create the account last.
 *
 * Three in four clients on prod created an account and never posted a job:
 * the account came before any value was shown. Here a visitor goes straight
 * into the wizard; the brief is kept as a guest draft and adopted by the
 * account they create at the final step (the wizard handles the hand-off).
 * A signed-in client just gets the normal wizard; other roles go to their
 * dashboard.
 */
const StartProjectPage = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && user && user.role && user.role !== 'client') navigate('/dashboard', { replace: true });
  }, [user, isLoading, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0f3d3a', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2 }}>
      <Seo title="Describe your project — Eqaya" description="Tell us what you want built in Zimbabwe. Verified contractors quote; nothing is paid until you approve the work." canonicalPath="/start" />
      <Box sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.85)', maxWidth: 520 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#fff', mb: 1 }}>Describe your project</Typography>
        <Typography variant="body2">
          No account needed to start. Verified contractors quote on it, and nothing is paid to anyone until you have seen the work and approved it.
        </Typography>
      </Box>
      <UnifiedProjectWizard
        open
        onClose={() => navigate(user ? '/projects' : '/')}
        onComplete={(projectId) => navigate(projectId ? `/projects/${projectId}` : '/projects')}
      />
    </Box>
  );
};

export default StartProjectPage;
